import styled, { keyframes } from "styled-components";
import theme from "../../../Styles/theme";

const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

export const Container = styled.div`
  width: ${window.screen.width > window.screen.height ? "30vw" : "90vw"};
  height: ${window.screen.width > window.screen.height ? "65vh" : "50vh"};
  background-color: ${theme.colors.light};
  margin-bottom: 2vh;
  padding: 1vh 1vw;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  border: 1px solid ${theme.colors.gray};
  animation: ${fadeIn} 0.4s ease;
  display: flex;
  flex-direction: column;
`;

export const DivX = styled.div`
  text-align: right;
  margin-bottom: 10px;
`;

export const HandleMessageContainer = styled.div`
  flex: 1;
  overflow-y: auto;
  padding-right: 8px;
  background-color: ${theme.colors.light2};
  border-radius: 8px;
  box-shadow: inset 0 1px 3px rgba(0, 0, 0, 0.1);

  &::-webkit-scrollbar {
    width: 6px;
  }
  &::-webkit-scrollbar-thumb {
    background-color: ${theme.colors.darkGrey};
    border-radius: 3px;
  }
`;

export const MessageContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 8px;
`;

export const Footer = styled.div`
  background-color: ${theme.colors.secondary};
  border-top: 1px solid ${theme.colors.gray};
  display: flex;
  align-items: center;
  padding: 8px 10px;
  border-radius: 8px;
  box-shadow: 0 -2px 4px rgba(0, 0, 0, 0.05);
  margin-top: 10px;
`;

export const MessageInput = styled.textarea`
  flex: 1;
  resize: none;
  padding: 10px 12px;
  border-radius: 8px;
  border: 1px solid ${theme.colors.gray};
  font-size: 1rem;
  background-color: ${theme.colors.light};
  color: ${theme.colors.dark};
  height: 40px;
  max-height: 80px;
  overflow-y: auto;

  &::-webkit-scrollbar {
    width: 5px;
  }
  &::-webkit-scrollbar-thumb {
    background-color: ${theme.colors.darkGrey};
    border-radius: 3px;
  }
`;

export const InputButton = styled.button`
  background-color: ${theme.colors.primary};
  color: white;
  border: none;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 8px;
  cursor: pointer;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  transition: background-color 0.2s;

  &:hover {
    background-color: ${theme.colors.primaryDark};
  }
`;

export const HelperInputs = styled.div``;

export const PLoader = styled.div`
  margin: auto;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const SpanMenssagens = styled.span`
  color: ${theme.colors.darkGrey};
  font-size: 0.9rem;
  text-align: center;
  margin-top: 10px;
`;



export const SendButton = styled.button`
  background-color: ${theme.colors.primary};
  border: none;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  transition: background-color 0.2s;

  &:hover {
    background-color: ${theme.colors.primaryDark};
  }

  svg {
    color: white;
  }
`;

export const AttachButton = styled.button`
  background-color: transparent;
  border: none;
  cursor: pointer;
  border-radius: 50%;
  padding: 6px;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    background-color: ${theme.colors.lightBluer};
  }

  svg {
    color: ${theme.colors.dark};
  }
`;
